module.exports = " <div class=loading v-if=show _v-0121c88f=\"\"> <img src=" + require("../../static/img/loading.gif") + " _v-0121c88f=\"\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0121c88f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = 395
// module chunks = 31